<template>
  <v-container>
    <v-form ref="form">
      <v-layout row wrap align-center justify-center>
        <v-flex lg8 md8 xs12>
          <v-toolbar color="pink" dark>
            <v-icon>perm_identity</v-icon>
            <v-toolbar-title>Login to Backoffice</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat color="white" :to="{ name: 'search-player' }">Check Register Number</v-btn>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-container fluid>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="username" @keyup.native.enter="login" label="Enter your username" :rules="[(x) => (x && x.length >= 3 && x.length <= 50 ? true : 'Provide your username')]" v-model="username" maxlength="50" type="text" counter></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field @keyup.native.enter="submit" name="password" label="Enter your password" hint="At least 5 characters" v-model="password" maxlength="50" min="5" :append-icon="hidePassword ? 'visibility' : 'visibility_off'" @click:append="() => (hidePassword = !hidePassword)" :rules="[(x) => (!!x ? true : 'Provide your password')]" :type="hidePassword ? 'password' : 'text'" counter></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat :loading="loading" color="green" v-on:click="submit">Login</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          <!-- <v-dialog v-model="showFeedback" :max-width="500">
            <v-card>
              <v-card-title class="headline">Login failed</v-card-title>
              <v-card-text>{{feedback}}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat="flat" @click.native="showFeedback = false">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
        </v-flex>
        <v-flex xs12>
          <v-snackbar v-model="showFeedback" color="error" :top="true" :timeout="5000">
            {{ feedback }}
            <v-btn dark flat @click="showFeedback = false">Close</v-btn>
          </v-snackbar>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
//import config from "../services/config";
import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      hidePassword: true,
      username: "",
      password: "",
      feedback: "Invalid username or password",
      showFeedback: false,
      loading: false,
    };
  },
  methods: {
    ...mapActions("config", { login: "login" }),
    submit: function() {
      if (!this.$refs.form.validate()) return;

      var me = this;
      me.loading = true;
      this.login({ username: me.username, password: me.password })
        .then((x) => {
          me.$cookies.set("__auth", x);
          me.$router.push({ name: "home" });
        })
        .catch(() => {
          me.showFeedback = true;
        })
        .finally(function() {
          me.loading = false;
        });
      //
      //  me.showFeedback=false;
      // this.$api("token")
      //   .post({ username: this.username, password: this.password })
      //   .then(x => {
      //     config.token = x.token;
      //     config.type=x.type;
      //     me.$router.push({name:"home"});
      //   })
      //   .catch(function(x) {
      //     console.log(x);
      //     me.showFeedback=true;
      //   });
    },
  },
};
</script>

<style></style>
